import { render, staticRenderFns } from "./LessonPreparationCenter.vue?vue&type=template&id=28e2b0e2&scoped=true"
import script from "./LessonPreparationCenter.vue?vue&type=script&lang=js"
export * from "./LessonPreparationCenter.vue?vue&type=script&lang=js"
import style0 from "./LessonPreparationCenter.vue?vue&type=style&index=0&id=28e2b0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2b0e2",
  null
  
)

export default component.exports